import { render } from "./Accreditation.vue?vue&type=template&id=e1c4b870&scoped=true"
import script from "./Accreditation.vue?vue&type=script&lang=js"
export * from "./Accreditation.vue?vue&type=script&lang=js"

import "./Accreditation.vue?vue&type=style&index=0&id=e1c4b870&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e1c4b870"]])

export default __exports__